import { render, staticRenderFns } from "./faqi-jieshou-form.vue?vue&type=template&id=5619846b&scoped=true"
import script from "./faqi-jieshou-form.vue?vue&type=script&lang=js"
export * from "./faqi-jieshou-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5619846b",
  null
  
)

export default component.exports